import React from 'react';
import PropTypes from 'prop-types';

const Header = ({ currentStep, onActionClick }) => (
  <>
    <h1 className="preferences-title">Email Preferences</h1>
    <div className="preferences-menu">
      <h2 className="preferences-menu-title">
        Manage Notifications
      </h2>
      <button
        className="edit"
        type="button"
        onClick={onActionClick}
      >
        {currentStep === 0 ? 'EDIT' : 'CANCEL'}
      </button>
    </div>
    <div className="divider" />
  </>
);

Header.defaultProps = {
  currentStep: 0,
  onActionClick: () => null,
};

Header.propTypes = {
  currentStep: PropTypes.number,
  onActionClick: PropTypes.func,
};

export default Header;
